import VaccinationAnalysisListStore from './vaccination.list';

export const vaccinationAnalysis = {
  list: VaccinationAnalysisListStore
};
